import React from 'react';

const LucideNavIcon = ({ icon: Icon, style }) => {
  const size =
    typeof style?.fontSize === 'string'
      ? parseFloat(style.fontSize) * 16
      : style?.fontSize || 16;

  return (
    <Icon
      size={size}
      strokeWidth={1.75}
      style={{
        verticalAlign: 'middle'
      }}
    />
  );
};

export default LucideNavIcon;